import type { IconData } from '@stacksjs/iconify-core'

export const switchRight: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M7 2a5 5 0 1 0 0 10h6a5 5 0 0 0 0-10zm0-2h6a7 7 0 0 1 0 14H7A7 7 0 0 1 7 0m6 11a4 4 0 1 1 0-8a4 4 0 0 1 0 8m0-2a2 2 0 1 0 0-4a2 2 0 0 0 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default switchRight
